import request from '@/utils/request'
import { isRunningInElectron } from '@/utils/electronUtils'

/**
 * 获取首页模块列表
 * @data {*} data
 */
export function coverModuleList(data) {
  return request({
    url: '/apiv2/aiClassroom/module/findCoverModuleList',
    method: 'post',
    data
  })
}

/**
 * 获取教辅模块关联试题模块列表
 * @data {*} data
 */
export function getModuleListByPid(data) {
  return request({
    url: '/apiv2/aiClassroom/module/getModuleListByPid',
    method: 'post',
    data
  })
}

/**
 * 根据父ID获取子模块列表
 * @data {*} data
 */
export function moduleListByPid(data) {
  return request({
    url: '/apiv2/aiClassroom/module/findModuleListByPid',
    method: 'post',
    data
  })
}

/**
 * 获取本地专版模块列表
 * @data {*} data
 */
export function especialList(data) {
  return request({
    url: '/apiv2/aiClassroom/module/findEspecialList',
    method: 'post',
    data
  })
}

/* ****************************************************** */

/**
 * 获取评测的松紧度
 * @data {*} data
 */
export function measureTightness(data) {
  return request({
    url: '/global/measureTightness',
    method: 'post',
    data
  })
}

/**
 * 获取给教学系统的阿里云Oss相关参数
 * @data {*} data
 */
export function userOssParam(data) {
  return request({
    url: '/apiv2/aiClassroom/common/getOssParam',
    method: 'post',
    data
  })
}

/**
 * 根据pid获取模块列表
 * @data {*} data
 */
// getModulesByPid
export function modulesByPid(data) {
  return request({
    url: '/entrance/getModulesByPid',
    method: 'post',
    data
  })
}

/**
 * 获取模块下的试题列表
 * @data {*} data
 */
export function findPaperList(data) {
  return request({
    url: '/index/findPaperList',
    method: 'post',
    data
  })
}

/**
 * 通过教师Id获取班级列表
 * @data {*} data
 */
export function clazzListByTeacherId(data) {
  return request({
    url: '/apiv2/aiClassroom/clazz/getListByTeacherId',
    method: 'post',
    data
  })
}

/**
 * 根据班级ID获取学生列表
 * @data {*} data
 */
export function studentListByClazzId(data) {
  return request({
    url: '/apiv2/aiClassroom/student/getListByClazzId',
    method: 'post',
    data
  })
}

/**
 * (超级教师)根据学校分页查询机房考试记录
 * @data {*} data
 */
export function findExamListBySchool(data) {
  return request(
    {
      url: '/apiv2/teacher/exam/getEarliestExamByClazz',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

/**
 * 获取作业包列表
 * @data {*} data
 */
export function findBagList(data) {
  return request(
    {
      url: '/homework/findBagList',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

/**
 * 根据班级ID获取学生分组
 * @data {*} data
 */
export function studentGroupByClazzId(data) {
  return request({
    url: '/apiv2/aiClassroom/student/getUserGroupListWithStudent',
    method: 'post',
    data
  })
}

/**
 * 读取文件
 * @data {*} data
 */
export function readFile(url) {
  return request({
    url: url
  })
}

/**
 * 创建课堂并返回课堂信息
 * @data {*} data
 */
export function classInfoByTeacherId(data) {
  return request({
    url: '/apiv2/aiClassroom/classroom/save',
    method: 'post',
    data
  })
}

/**
 * 客户端检查更新
 * @data {*} data
 */
export function checkVersion() {
  // 固定传
  const device = 'windows-pc'
  let release = null
  if (isRunningInElectron()) {
    release = window.electron.versions.app
  }
  return request({
    url: '/apiv2/aiClassroom/common/checkVersion',
    method: 'post',
    data: {},
    headers: {
      release,
      device
    }
  })
}

/**
 * 通过学生id获取学生信息
 * @data {*} data
 */
export function getUserListByIds(data) {
  return request({
    url: '/apiv2/aiClassroom/user/getUserListByIds',
    method: 'post',
    data
  })
}

// 查询单词信息
export function selectByWordName(data) {
  return request({
    url: '/apiv2/aiClassroom/course/selectByWordName',
    method: 'post',
    data
  })
}

/**
 * 获取上传文件阿里云证书
 * @data {*} data
 */
export function getImportOssResource(data) {
  return request({
    url: '/apiv2/aiClassroom/common/getImportOssResource',
    method: 'post',
    data
  })
}

/**
 * 获取行政区划信息-树型
 * @data {*} data
 */
export function areaCityTree(data) {
  return request({
    url: '/apiv2/common/area/cityTree',
    method: 'post',
    data
  })
}

/**
 * 获取当前接收器绑定的答题器列表信息
 * @data {*} data
 */
export function searchByReceiver(data) {
  return request({
    url: '/apiv2/aiClassroom/answerMachine/searchByReceiver',
    method: 'post',
    data
  })
}

/**
 * 接收器绑定答题器
 * @data {*} data
 */
export function receiverBatchBindDTQ(data) {
  return request({
    url: '/apiv2/aiClassroom/answerMachine/batchBind',
    method: 'post',
    data
  })
}

/**
 * 根据字典pram获取字典列表
 * @param data
 * @returns {*}
 */
export function findListByParam(data) {
  return request({
    url: '/apiv2/aiClassroom/common/dict/findListByParam',
    method: 'post',
    data
  })
}

/**
 * 批量更新学生的班级内序号
 * @param data
 * @returns {*}
 */
export function batchUpdateStudentSeq(data = {}) {
  return request({
    url: 'apiv2/aiClassroom/student/batchUpdateSeq',
    method: 'post',
    data
  })
}
